// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"1":"c608bfa1","43":"c61f7f10","374":"754612e9","399":"59dbb4c4","437":"b1bb8b88","616":"958c5c35","628":"9218a16c","841":"ca48cca7"}[chunkId] + ".chunk.js";
};